module.exports = __webpack_public_path__ + "media/images/landing/en/save_time-6387f6679553a7b2331adfef41ae6878.png";